module.exports = __webpack_public_path__ + "img/special2.1fc5cc1b.webp";